/**
 * Servicio que conecta con la API las inspecciones de las incidencias
 */
CampoExtraService.$inject = ['$http'];
export default function CampoExtraService($http) {
    var urlBase = Sigo.var.path + '/api/v1' + '/campos-extra' + '/';

    var _get = function (modelId, soloObligatorios) {
        var url = urlBase + modelId;

        if (soloObligatorios) url += '?obligatorios=true';

        return $http.get(url);
    };

    var _update = function (modelId, dataCampoExtra) {
        return $http.patch(urlBase + modelId, dataCampoExtra);
    };

    var _delete = function (modelId, campoExtraId) {
        return $http.delete(urlBase + modelId + '?campoExtraId=' + campoExtraId);
    };

    return {
        get: _get,
        update: _update,
        delete: _delete
    };
}